import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *运营成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/yy`, { params })

/**
 *运营评分列表
 * @param params
 * 
*/

export const scoreList = params => Http.get(`${baseUrl}/sz/team/yy`, { params })

/**
 *新增评价项目
 * @param params
 * 
*/

export const addItem = params => Http.post(`${baseUrl}/sz/team/yy/item`, params )

/**
 *修改评价项目
 * @param params
 * 
*/

export const editItem = params => Http.put(`${baseUrl}/sz/team/yy/item`, params )

/**
 *删除评价项目
 * 
*/

export const delItem = ids => Http.delete(`${baseUrl}/sz/team/yy/item/${ids}` )

/**
 *评价项目列表
 * @param params
 * 
*/

export const itemList = params => Http.get(`${baseUrl}/sz/team/yy/item`, { params })

/**
 *评价项目排序
 * @param params
 * 
*/

export const sort = params => Http.put(`${baseUrl}/sz/team/yy/item/sort`,  params )

/**
 *评价项目类型列表
 * @param params
 * 
*/

export const itemTypeList = params => Http.get(`${baseUrl}/sz/team/yy/item/types`, { params })

/**
 *评价详情
 * @param teamId
 * 
*/

export const evaluateInfo = teamId => Http.get(`${baseUrl}/sz/team/yy/${teamId}/score`)

/**
 *提交评分
 * @param params
 * 
*/

export const doEvaluate = params => Http.post(`${baseUrl}/sz/team/yy/${params.teamId}/score`, params.result )

/**
 *团队排行
 * @param classId
 * 
*/

export const teamRanking = classId => Http.get(`${baseUrl}/sz/team/yy/${classId}/top`)

/**
 *结算成绩
 * @param classId
 * 
*/

export const settle = classId => Http.post(`${baseUrl}/sz/team/yy/${classId}/complete`)
